import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from 'translations/en.json';
import pt from 'translations/pt.json';
import tr from 'translations/tr.json';
import hi from 'translations/hi.json';
import fr from 'translations/fr.json';
import es from 'translations/es.json';
import it from 'translations/it.json';
import de from 'translations/de.json';
import ru from 'translations/ru.json';
// import ko from 'translations/ko.json';
// import ja from 'translations/ja.json';
import pl from 'translations/pl.json';
import ar from 'translations/ar.json';
import he from 'translations/he.json';

i18next.use(initReactI18next).init({
  lng: 'en',
  fallbackLng: 'en',
  react: {
    transSupportBasicHtmlNodes: true,
  },
  resources: {
    en: {
      translation: en,
    },
    fr: {
      translation: fr,
    },
    es: {
      translation: es,
    },
    pt: {
      translation: pt,
    },
    it: {
      translation: it,
    },
    de: {
      translation: de,
    },
    ru: {
      translation: ru,
    },
    // TODO: Temporary disable this languages until translations updated.
    // ko: {
    //   translation: ko,
    // },
    // ja: {
    //   translation: ja,
    // },
    ar: {
      translation: ar,
    },
    hi: {
      translation: hi,
    },
    pl: {
      translation: pl,
    },
    he: {
      translation: he,
    },
    iw: {
      translation: he,
    },
    tr: {
      translation: tr,
    },
  }
});
